import APIConnector from "../lib/APIConnector";
import FirebaseConnector from "../lib/FirebaseConnector";
import { SERVER_URL } from "../config/Endpoints";

const firebaseConnector = new FirebaseConnector({ timeout: 30000 });
const apiConnector = new APIConnector({ timeout: 30000 });

export default class AuthConfig {
  static get base() {
    return SERVER_URL + "/verifyToken";
  }

  static get endpointVerifyToken() {
    return `${AuthConfig.base}/isAllowed`;
  }

  static get FirebaseConnector() {
    return firebaseConnector;
  }

  static get APIConnector() {
    return apiConnector;
  }
}



// WEBPACK FOOTER //
// ./src/provider/auth/AuthConfig.js